import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    getGalleries: (state) => {
      state.loading = true;
    },
    addGallery: (state) => {
      state.loading = true;
    },
    updateGallery: (state) => {
      state.loading = true;
    },
    removeGallery: (state) => {
      state.loading = true;
    },
    getOneGallery: (state) => {
      state.loading = true;
    },
    successGallery: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneGallery: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedGallery: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getGalleries,
  addGallery,
  updateGallery,
  removeGallery,
  getOneGallery,
  successGallery,
  successOneGallery,
  failedGallery,
} = gallerySlice.actions;

export default gallerySlice.reducer;